import { Position } from '@shared/model/position.model';

export const streetViewUrlForLocation = (position: Position): string =>
  `https://www.google.com/maps?layer=c&cbll=${position.lat},${position.long}`;
